export default "__VITE_ASSET__CV9MAw1E__"